import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-148" data-mp="3k06wnu4a0ry9">
      {eyebrow ? <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-amethyst" data-id="element-149" data-mp="3k202x8az9a5q">
          {eyebrow}
        </p> : null}
      <h2 className="mt-3 font-display text-3xl leading-tight text-cream sm:text-4xl lg:text-[42px]" data-id="element-150" data-mp="gjq2lywwmlj9">
        {title}
      </h2>
      {subtitle ? <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-151" data-mp="1uae6pkuis6q">{subtitle}</p> : null}
    </div>;
}